export default __webpack_public_path__ + "static/media/Commander's Helm of the Warring States.ebeca04e.jpg";